import WigIcon from "./WigIcon";
import styled from "@emotion/styled";

const Wrapper = styled.div`

`


const WigIconWrapper = ({ dimensions = "2rem", opacity = .7, ...props }) => {

  return (
    <div style={{height: dimensions, width: dimensions, opacity}}>
      <WigIcon {...props} />
    </div>
  )
  
};

export default WigIconWrapper;